import type { ProficiencyAssessmentFinalResult } from '@/features/nectar/api/models'
import { Button, Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { CheckCheck } from 'lucide-react'

type PhaseResultsProps = {
  finalResult: ProficiencyAssessmentFinalResult
  onBack: () => void
  hideBackAction?: boolean
}

export const PhaseResults = ({ finalResult, onBack, hideBackAction = false }: PhaseResultsProps) => {
  return (
    <div
      className="mx-auto flex w-full max-w-[600px] flex-col items-center gap-6 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center"
      style={{ animation: 'nectar-slide-up 0.4s ease-out' }}
    >
      <div className="bg-green/10 flex size-16 items-center justify-center rounded-full">
        <CheckCheck className="text-green size-8" />
      </div>

      <Text type="h5">
        <Trans>Assessment Complete!</Trans>
      </Text>

      <div className="flex flex-col items-center gap-2">
        <span className="text-h3 block">{finalResult.level}</span>
        <Text type="body2-regular" className="text-gray-80">
          <Trans>Your estimated CEFR level</Trans>
        </Text>
      </div>

      {!hideBackAction && (
        <Button size="small" onClick={onBack} className="mt-2">
          <Trans>Back to Missions</Trans>
        </Button>
      )}
    </div>
  )
}
